import { Input } from 'antd';

const { TextArea } = Input;

export const BaseCustomTextArea = ({
  placeholder = 'Enter text...',
  className = '',
  ...props
}) => {
  return (
    <TextArea
      placeholder={placeholder}
      className={className}
      {...props}
    />
  );
};